import { ContactsState } from 'Contacts/Store/initialState'
import { UiState } from 'UI/Store/initialState'
import { ProjectsState } from 'Projects/Store/initialState'
import { UserState } from 'Header/Types/types'
import { CompanyState } from 'Companies/Store/initialState'

export interface ApplicationState {
  user: UserState
  companies: CompanyState
  loggedIn: boolean
  loading: boolean
  error: null
  hasLoggedOut: boolean
  contacts: ContactsState
  ui: UiState
  projects: ProjectsState
}

const initialState = {
  userData: null,
  loggedIn: false,
  loading: true,
  error: null,
  hasLoggedOut: false
}

export default initialState
